// extracted by mini-css-extract-plugin
module.exports = {"symbol":"styles_symbol__NFx8C"};